import { createContext, ReactElement, useContext, useState } from 'react'

type OnChangeDetectContextProps = {
  refresh: any
  setRefresh: any
}

type OnChangeDetectProviderProps = {
  children: ReactElement
}

const OnChangeDetectContext = createContext<OnChangeDetectContextProps>(
  {} as OnChangeDetectContextProps
)

export const OnChangeDetectProvider = ({
  children
}: OnChangeDetectProviderProps) => {
  const [refresh, setRefresh] = useState(false)

  return (
    <OnChangeDetectContext.Provider
      value={{
        refresh,
        setRefresh
      }}
    >
      {children}
    </OnChangeDetectContext.Provider>
  )
}

export const useOnChangeDetect = () => {
  const context = useContext(OnChangeDetectContext)

  if (!context)
    throw new Error(
      'useOnChangeDetect must be used within a provider OnChangeDetectProvider'
    )

  return { ...context }
}
